module.exports = __webpack_public_path__ + "static/img/pavilion_default.acb54842.png";